import * as Sentry from '@sentry/sveltekit';

import { Bench } from '$lib/bench';

import { initAnalytics } from './hooks.client.analytics';
import { tryCreateClientRepo } from './hooks.client.repo';
import { initSentry } from './hooks.client.sentry';

Bench.mark('sveltekit.hooks.client');
Bench.measure('sveltekit.init', 'document.head');

initSentry();

export function init() {
	tryCreateClientRepo();
	initAnalytics();
}

export const handleError = Sentry.handleErrorWithSentry();
